var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"m-news-item"},[_c('div',{staticClass:"div_img"},[_c('img',{attrs:{"src":_vm.news.pic,"alt":""}})]),_c('div',{staticClass:"div_mid"},[_c('h2',[_vm._v(_vm._s(_vm.news.title))])]),_c('div',{staticClass:"div_right"},[_c('span',[_vm._v(_vm._s(_vm.news.date))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }